export default {
  title: "供應商關係管理系統",
  systemSetting: "系統設置",
  logout: "退出登錄",
};
